export const AUDIO_OUTPUT_DEVICE_ID = 'audio_output_device_id';
export const LAST_VIDEO_INPUT_ID = 'last_video_input_id';
export const LAST_AUDIO_INPUT_ID = 'last_audio_input_id';
export const LAST_AUDIO_OUTPUT_ID = 'last_audio_output_id';
export const LOCAL_VIDEO_MUTED = 'local_video_muted';
export const LOCAL_AUDIO_MUTED = 'local_audio_muted';
export const CURRENT_CALENDAR_VIEW = 'current_calendar_view';
export const SKIP_EXERCISE_CREATE_INSTRUCTIONS_OFFICE = 'skip_exercise_create_instructions_office';
export const SKIP_EXERCISE_CREATE_INSTRUCTIONS_PATIENT =
  'skip_exercise_create_instructions_patient';
export const VERSION = 'version';
export const SIGNUP_SCENARIO = 'signup_scenario';
export const HEALTH_CHECK_SHOWN = 'health_check_shown';
export const QR_EXERCISE = 'qr_exercise';
export const INSTALL_PROMPT_SHOWN = 'install_prompt_shown';
export const CURRENT_ONBOARING_PATENT_STEP = 'current_onboarding_patient_step';
export const EXERCISE_EXECUTION_AUDIO_IS_MUTED = 'exerciseExecution_audioIsMuted';
export const EXERCISE_EXECUTION_AUTO_CONTINUE = 'exerciseExecution_autoContinue';
export const ADMIN_DASHBOARD_LAYOUT = 'admin_dashboard_layout';
export const USER_TREATMENTS = 'user_treatments';
